import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/places/_layout/settings')({});